module.exports = __webpack_public_path__ + "img/school.7f43fb89.svg";